<template>
  <div>
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

        <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Fetch Canteen Application</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
          <v-row fluid justify="center">
            <v-radio-group v-model="radios" row>
                <v-radio label="All"  @change="learner_canteen_fees_installment_details_new = []" value="all"></v-radio>
                <v-radio label="Fetch Cancel Requests" @change="learner_canteen_fees_installment_details = []" value="requests"></v-radio>
            </v-radio-group>
        </v-row>
        </v-card>
         <v-card class="box" v-if="radios == 'requests'">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Cancel Transport Application</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <br>
        <v-row justify="center" dense>
           <v-col cols="12" sm="1"></v-col>
          <v-col cols="12" sm="2">
            <!-- <p><v-icon color="error">*</v-icon><b>Academic Year</b></p> -->
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="ay_fetch"
              :items="ay_list"
              item-text="ay"
              item-value="id"
              label="Academic Year"
              outlined
              persistent-hint
              hint="Please Select Academic Year"
            />
          </v-col>
           <v-col col="12" sm="4" md="4">
            <v-btn color="warning" @click="fetchCancelRequest()">Fetch Cancel Requests</v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="box" v-if="radios == 'all'">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Cancel Canteen Application</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="2">
            <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="ay"
              :items="ay_list"
              item-text="ay"
              item-value="id"
              label="Academic Year"
              outlined
              persistent-hint
              hint="Please Select Academic Year"
              @change="getInstallmentData()"
            />
          </v-col>
          <v-col cols="12" sm="2" v-if="canteen_installment_list!=''">
            <p><b>Installment</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="canteen_installment"
              :items="canteen_installment_list"
              item-text="name"
              item-value="id"
              label="Canteen Installment"
              outlined
              persistent-hint
              hint="Please Select Installment"
            />
          </v-col>
          <v-col cols="12" sm="3" v-if="all_learner_list!=''">
            <p><b>Learner</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="learner"
              :items="all_learner_list"
              item-text="learner"
              item-value="id"
              label="Student"
              outlined
              persistent-hint
              hint="Please Select Student"
            />
          </v-col>
        </v-row>
        <!-- //v-if="this.canteen_installment && this.canteen_status && this.learner"> -->
        <v-row justify="center" dense>
          <v-col cols="12" sm="2" md="2"></v-col>
          <v-col col="12" sm="4" md="4">
            <v-btn color="warning" @click="fetch()">Fetch</v-btn>
          </v-col>
        </v-row>
      </v-card>

      <!-- {{learner_canteen_fees_installment_details.length}} -->
      <v-card
        class="box"
        v-if="learner_canteen_fees_installment_details!=''"
      >
        <v-data-table
          :headers="headers_2"
          :items="learner_canteen_fees_installment_details"
          :search="search"
        >
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>List</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
           <template v-slot:[`item.action`]="{ item }">
            <div v-if="item.is_blocked_for_canteen==false && item.iscancelled==false && item.cancancel== true">
                <v-btn color="warning" @click="markApprove(item)">Cancel</v-btn>
            </div>
             <div v-else-if="item.iscancelled==true">
               <b>Already Cancelled...</b>
             </div>
              <div v-else-if="item.cancancel==false">
               <b>Cannot Cancel..Fees Paid</b> 
             </div>
             <div v-else>
              <b>Student Is Blocked For Canteen Facility...</b>
            </div>
          </template>
           <template v-slot:[`item.sync_amount`]="{ item }">
             <!-- <div v-if="item.sync_amount == 0 ">
               <b>Application Not Approved Yet...</b>
             </div>
             <div v-else> -->
               {{item.sync_amount}}
             <!-- </div> -->
          </template>
          
        </v-data-table>
      </v-card>

       <v-card
        class="box"
        v-if="learner_canteen_fees_installment_details_new!=''"
      >
        <v-data-table :headers="headers_2" :items="learner_canteen_fees_installment_details_new" :search="search" >
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Cancel Request List</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </v-toolbar>
          </template> 
          <template v-slot:[`item.action`]="{ item }">
            <div v-if="item.is_blocked_for_canteen==false && item.iscancelled==false && item.cancancel== true">
              <v-btn color="warning" @click="markCancelRequest(item)">Cancel</v-btn>
            </div>
             <div v-else-if="item.iscancelled==true">
               <b>Already Cancelled...</b>
             </div>
              <div v-else-if="item.cancancel==false">
               <b>Cannot Cancel..Fees Paid</b> 
             </div>
             <div v-else>
              <b>Student Is Blocked For Transport...</b>
            </div>
          </template>
           <template v-slot:[`item.sync_amount`]="{ item }">
             <!-- <div v-if="item.sync_amount == 0 ">
               <b>Application Not Approved Yet...</b>
             </div>
             <div v-else> -->
               {{item.sync_amount}}
             <!-- </div> -->
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    radios:null,
    search: "",
    is_final_approved: false,
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    ay_list: [],
    ay: "",ay_fetch:"",
    standard_list: [],
    standard: "",
    canteen_status_list: [],
    canteen_status: "",
    canteen_installment_list: [],
    canteen_installment: "",
    all_learner_list: [],
    learner: "",
    learner_canteen_fees_installment_details: [],
    learner_canteen_fees_installment_details_new: [],
    show_approve_transport_card: false,
    child_details: {
      lid: "",
      registration_number: "",
      learner: "",
      standard: "",
      academicYear: "",
      totalfees: "",
      paid_till_now: "",
      applicable_fees: "",
      canteen_installment_amount: "",
      canteen_installment: "",
    },
    totalfees_approved: "",

    canteen_installment_list: [],
    canteeninstallment: "",
    canteen_status_list: [],
    canteenstatus: "",
    approve_remark: "",
    learnercanteenfeesinstallment: "",
    canteenApprovalDetails: [],
    show_approve_history_card: false,
    canteenApplicationsDetails: [],
    learner_canteen_fees_installment_id: "",
    headers: [
      { text: "SR No", value: "srno" },
      // { text: "PRN", value: "prn" },
      { text: "Student", value: "name" },
      { text: "Installment", value: "canteeninstallment" },
      // { text: "Fees In Rs", value: "totalfees" },
      { text: "Amount To Pay", value: "amount" },
      { text: "Paid Till Now", value: "paid_till_now" },
      { text: "Your Approval Status", value: "your_status" },
      { text: "Final Approval Status", value: "canteenapprovalstatus" },
      { text: "Action", value: "action" },
      { text: "My Approval Status", value: "history" },
    ],
     headers_2: [
      { text: "SR No", value: "srno" },
      // { text: "PRN", value: "prn" },
      { text: "Student", value: "name" },
      { text: "Installment", value: "canteeninstallment" },
    //   { text: "Fees In Rs", value: "amount" },
      { text: "Amount To Pay", value: "sync_amount" },
      { text: "Paid Till Now", value: "sync_paid_till_now" },
       { text: "Application Date", value: "application_date" },
       { text: "Cancel Request Date", value: "cancellation_request_date" },
       { text: "Cancel Date", value: "cancelled_date" },
      // { text: "Your Approval Status", value: "your_status" },/
      // { text: "Final Approval Status", value: "canteenapprovalstatus" },
      { text: "Action", value: "action" },
      // { text: "My Approval Status", value: "history" },
    ],
    canteen_fee_sync:false
  }),
  methods: {
      markApprove(item){
          if (!confirm("Are You Sure You Want To cancel Request...?")) return;
          const data = {
              learner_canteen_fees_installment: item.id,
          };
          this.overlay = true;
          axios
              .post("/Canteen/markCancelCanteen", data)
              .then((res) => {
              if (res.data.flag == "YES") {
                  // this.learner_transport_fees_installment_details =res.data.learner_transport_fees_installment_details;
                  this.fetch()
                  this.showSnackbar("green", "Request Is Cancelled");
              } else if (res.data.flag == "No") {
                  this.showSnackbar("red", res.data.snackbar);
              } else {
                  this.showSnackbar("red", res.data.snackbar);
                  sessionStorage.setItem("error-trace", res.data.error_trace);
              }
              this.overlay = false;
              })
              .catch((error) => {
              this.onerror(error);

              this.overlay = false;
              })
              .finally(() => {
              this.overlay = false;
              });
             },
              markCancelRequest(item){
          if (!confirm("Are You Sure You Want To cancel Request...?")) return;
          const data = {
              learner_canteen_fees_installment: item.id,
          };
          this.overlay = true;
          axios
              .post("/Canteen/markCancelCanteen", data)
              .then((res) => {
              if (res.data.flag == "YES") {
                  // this.learner_transport_fees_installment_details =res.data.learner_transport_fees_installment_details;
                  this.showSnackbar("green", "Request Is Cancelled");
              } else if (res.data.flag == "No") {
                  this.showSnackbar("red", res.data.snackbar);
              } else {
                  this.showSnackbar("red", res.data.snackbar);
                  sessionStorage.setItem("error-trace", res.data.error_trace);
              }
              this.overlay = false;
              })
              .catch((error) => {
              this.onerror(error);
              this.overlay = false;
              })
              .finally(() => {
              this.overlay = false;
              this.fetchCancelRequest()
              });
             },
    getInstallmentData(){
    this.canteen_installment_list=[],
    this.all_learner_list=[], this.learner_canteen_fees_installment_details =[]
    const data = {
        academicYear: this.ay
    };
    this.overlay = true;
    axios
        .post("/Canteen/getInstallmentDataByAy", data)
        .then((res) => {
        if (res.data.flag == "YES") {
            this.canteen_installment_list = res.data.canteen_installment_list;
            this.all_learner_list = res.data.all_learner_list;
            if(this.canteen_installment_list==''){
                this.showSnackbar("red", "Installment List Not Defined For This Academicyear...");    
                return
            }           
        } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
        }
        this.overlay = false;
        })
        .catch((error) => {
        this.onerror(error);

        this.overlay = false;
        })
        .finally(() => {
        this.overlay = false;
        });
    },
    saveApproveStatus() {
      if (!confirm("Are You Sure You Want To Save...?")) return;
      if (this.canteenstatus == null || this.canteenstatus == "") {
        this.showSnackbar("red", "Please Select Status");
        return;
      }
      const data = {
        learnercanteenfeesinstallment: this.learnercanteenfeesinstallment,
        canteenstatus: this.canteenstatus,
        remark: this.approve_remark,
        canteeninstallment: this.canteeninstallment,
        total_fees: this.applicable_fees,
      };
      this.overlay = true;
      axios
        .post("/Canteen/saveApproveStatusLevelOne", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.show_approve_transport_card = false), this.fetch();
            this.showSnackbar("green", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    editItem(item) {
      this.canteenstatus = "";
      this.learner_canteen_fees_installment_id = item.id;
      const data = {
        learner_canteen_fees_installment: item.id,
      };
      this.overlay = true;
      axios
        .post("/Canteen/fetchCanteenApplicationsDetails", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            //this.showSnackbar("green", res.data.snackbar);
            this.child_details.registration_number =
              res.data.registration_number;
            this.child_details.learner = res.data.learner;
            this.child_details.lid = res.data.lid;
            this.child_details.standard = res.data.standard;
            this.child_details.academicYear = res.data.academicYear;
            this.child_details.totalfees = res.data.totalfees;
            this.child_details.applicable_fees = res.data.applicable_fees;
            this.child_details.paid_till_now = res.data.paid_till_now;
            this.child_details.canteen_installment_amount =
              res.data.canteen_installment_amount;
            this.child_details.canteen_installment =
              res.data.canteen_installment;

            this.canteen_installment_list = res.data.canteen_installment_list;
            this.canteen_status_list = res.data.canteen_status_list;
            //this.canteeninstallment=res.data.canteen_installment_id
            this.learnercanteenfeesinstallment =
              res.data.learnercanteenfeesinstallment;
            this.is_final_approved = res.data.is_final_approved;
            this.show_approve_transport_card = true;
            // this.learner_canteen_fees_installment_details=res.data.learner_canteen_fees_installment_details
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    fetch() {
       if(this.canteen_installment==''){
          this.showSnackbar("red","Please Select Installment");
            return
      }
      if(this.learner==''){
          this.showSnackbar("red","Please Select Students");
          return
      }
      const data = {
        academicYear: this.ay,
        learner: this.learner,
        canteen_installment: this.canteen_installment,
      };
      this.overlay = true;
      axios
        .post("/Canteen/fetchCanteenApplicationsToCancel", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.learner_canteen_fees_installment_details =res.data.learner_canteen_fees_installment_details;
            this.canteen_fee_sync=res.data.canteen_fee_sync
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    onLoad() {
      axios
        .post("Canteen/cancelCanteenApplicationHome")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.ay_list = res.data.ay_list), 
            //(this.ay = res.data.curreny_ay);
            this.canteen_installment_list = res.data.canteen_installment_list;
            //this.all_learner_list = res.data.all_learner_list;
            this.overlay = false;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
     fetchCancelRequest(){
      const data = {
        ay:this.ay_fetch
      };
      this.overlay = true;
       axios
        .post("/Canteen/fetchCancelRequest", data)
        .then((res) => {
          if (res.data.flag == "YES") {
             this.learner_canteen_fees_installment_details_new =res.data.learner_canteen_fees_installment_details;
             this.canteen_fee_sync=res.data.canteen_fee_sync
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>